import { buildWidgetInstanceId } from "features/widgets";
import React from "react";
import { useCollectedData } from "shared/contexts/PageData";
import { useViewMode } from "shared/contexts/ViewMode";

import styles from "./Content012.module.scss";
import { GridView } from "./GridView";
import { SliderView } from "./SliderView";

export const Content012 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId("012", payload.id);
  const { events, articles } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
    { name: "articles", defaultValue: [] },
  ]);

  const { isMobile } = useViewMode();
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const contentType = payload?.contentType ?? "";

  return (
    <div className={styles.wrapper}>
      {isMobile ? (
        <GridView
          title={title}
          description={description}
          contentType={contentType}
          events={events}
          articles={articles}
        />
      ) : (
        <SliderView
          title={title}
          description={description}
          contentType={contentType}
          events={events}
          articles={articles}
        />
      )}
    </div>
  );
};

export default Content012;
